/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_JBP_EXECUTION_BY_STORE = gql`
  query GetJBPExecutionByStore($input: JBPReportInput!) {
    jbpExecutionByStore(input: $input) {
      results {
        id
        name
        planName
        coldVaultComplianceNumerator
        coldVaultComplianceDenominator
        auditQuestionComplianceNumerator
        auditQuestionComplianceDenominator
        combinedCompliance
      }
      count
    }
  }
`
